/**
 * base64转换文件
 * @params {base64, FileName, FileName}
 * @returns {Object} File
 */
export const dataURLtoFile = (dataurl, name, type) => {
  var arr = dataurl.split(","),
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], name, {
    type: type
  })
}

/**
 * blob 转 base64
 * @params {base64, FileName, FileName}
 * @returns {Object} File
 */
export const blobToBase = (blob) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onload = (e) => {
      resolve(e.target.result)
    }
    // readAsDataURL
    fileReader.readAsDataURL(blob)
    fileReader.onerror = () => {
      reject(new Error("转换失败"))
    }
  })
}

/**
 * 十六制随机数切割
 * @returns {Object}
 */
export const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * 合成水印
 * @params {File, args}
 * args 水印坐标 x,y,w,h
 * @returns {String} base64
 */
export const drawImage = (file, args) => {
  return new Promise((resolve, reject) => {
    console.log(1, file)
    console.log(args)
    if (!file) {
      reject({
        code: 100,
        msg: "暂未上传文件"
      })
      return
    }
    var canvas = document.createElement("canvas")
    let ctx = canvas.getContext("2d")
    let coversImage = new Image()
    // coversImage.src = require('../assets/img/zsImage.png');
    let newImage = new Image()
    newImage.onload = function () {
      // alert('进入onload方法!');
      canvas.width = newImage.width
      canvas.height = newImage.height
      ctx.drawImage(newImage, 0, 0)
      ctx.drawImage(coversImage, args.x, args.y, args.w, args.w)
      let imgSrc = canvas.toDataURL()
      resolve(imgSrc)
    }
    newImage.src = file.content
    // newImage.onerror = err =>{
    // 	console.log(err);
    // 	alert('进入onerror方法!');
    // }
  })
}

/**
 * 压缩图片
 * @params {base64, File}
 * @returns {Object} file
 */
export const compress = (bese64, file) => {
  return new Promise((resolve) => {
    let img = new Image()
    img.src = bese64
    console.log(img)
    img.onload = function () {
      console.log(img.width, img.height)
      let canvas = document.createElement("canvas")
      let ctx = canvas.getContext("2d")
      //瓦片canvas
      let tCanvas = document.createElement("canvas")
      let tctx = tCanvas.getContext("2d")
      // let initSize = img.src.length;
      let width = img.width
      let height = img.height
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio
      if ((ratio = (width * height) / 4000000) > 1) {
        ratio = Math.sqrt(ratio)
        width /= ratio
        height /= ratio
      } else {
        ratio = 1
      }
      canvas.width = width
      canvas.height = height
      //铺底色
      ctx.fillStyle = "#fff"
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      //如果图片像素大于100万则使用瓦片绘制
      let count
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1) //计算要分成多少块瓦片
        //计算每块瓦片的宽和高
        let nw = ~~(width / count)
        let nh = ~~(height / count)
        tCanvas.width = nw
        tCanvas.height = nh
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            )
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height)
      }
      //进行最小压缩
      let data = canvas.toDataURL("image/jpeg", 0.5)
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0
      //进行转换文件
      let fileData = dataURLtoFile(data, file.name, file.type)
      console.log("最小压缩", fileData)
      resolve(fileData)
    }
  })
}

/**
 * 合成图片
 * @params {cropImage, imgArgs, text, textArgs}
 * @returns {String} base64
 */
export const drawPoster = (image, imgArgs, text, posterbg, nickName, avatar) => {
  console.log("ava" + avatar);
  return new Promise((resolve, reject) => {
    console.log("海报", posterbg);
    if (!image) {
      reject({
        code: 100,
        msg: "暂未上传文件"
      });
      return;
    }
    // var img = document.getElementById("img");
    var canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");

    let cropimage = new Image();
    cropimage.src = image;

    let avatarImage = new Image();
    avatarImage.src = avatar;
    avatarImage.setAttribute("crossOrigin", "anonymous");

    let newPoster = new Image();
    newPoster.src = posterbg;
    newPoster.setAttribute("crossOrigin", "anonymous");

    newPoster.onload = function () {
      canvas.width = newPoster.width;
      canvas.height = newPoster.height;

      // ctx.fillStyle = "#fff";
      // ctx.fillRect(0, 0, 750, 1333);
      // ctx.drawImage(cropimage, args.x, args.y, args.w, args.h)
      ctx.drawImage(
        cropimage,
        imgArgs.sx,
        imgArgs.sy,
        imgArgs.sw,
        imgArgs.sh,
        imgArgs.dx,
        imgArgs.dy,
        imgArgs.dw,
        imgArgs.dh
      );

      avatarImage.onload = function () {
        ctx.save();
        let cx = 90 + 80;
        let cy = 575 + 80;
        ctx.arc(cx, cy, 80, 0, 2 * Math.PI);
        ctx.strokeStyle = "#FFFFFF"; // 设置绘制圆形边框的颜色
        ctx.stroke(); // 绘制出圆形，默认为黑色，可通过 ctx.strokeStyle = '#FFFFFF'， 设置想要的颜色
        ctx.clip();
        ctx.fill();
        ctx.drawImage(avatarImage, 0, 0, avatarImage.width, avatarImage.height, 90, 575, 160, 160);

        ctx.restore();

        ctx.drawImage(newPoster, 0, 0);

        ctx.font = '50px "中黑"';
        ctx.fillStyle = "#EF662A";
        ctx.textBaseline = "top";
        ctx.fillText(nickName, 260, 673);

        ctx.font = '45px "中黑"';
        ctx.fillStyle = "#3A6294";
        ctx.textBaseline = "top";
        ctx.fillText(text, 247, 1764);

        let imgSrc = canvas.toDataURL();
        resolve(imgSrc);
      };
    };
    // newPoster.src = require("../assets/img/posterbackground.png")
  });
};

/**
 * 转base64
 * @returns {String} base64
 */
export const urlToBase64 = (src) => {
  return new Promise((resolve, reject) => {
    let image = new Image()
    image.onload = function () {
      let canvas = document.createElement("canvas")
      canvas.width = image.width
      canvas.height = image.height
      // 将图片插入画布并开始绘制
      const ctx = canvas.getContext("2d")
      ctx.drawImage(image, 0, 0, image.width, image.height)
      const dataURL = canvas.toDataURL("image/png")
      resolve(dataURL)
    }
    // CORS 策略，会存在跨域问题https://stackoverflow.com/questions/20424279/canvas-todataurl-securityerror
    // image.setAttribute("crossOrigin", "Anonymous")
    image.crossOrigin = "Anonymous"
    image.src = src
    // 图片加载失败的错误处理
    image.onerror = () => {
      reject(new Error("转换失败"))
    }
  })
}
